import { memo } from "react";

function TemplateDownload() {
  return (
    <svg
      width="18px"
      height="18px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18 12C18.7 12 19.37 12.13 20 12.35V8L14 2H4C2.89 2 2 2.89 2 4V18C2 19.11 2.9 20 4 20H12.35C12.13 19.37 12 18.7 12 18C12 14.69 14.69 12 18 12ZM13 3.5L18.5 9H13V3.5Z"
        fill="currentColor"
      />
      <path
        d="M22.3242 17.6923H19.8627V14H16.1704V17.6923H13.7089L18.0165 22L22.3242 17.6923Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default memo(TemplateDownload);
